"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onClickPurchaseErrorModalClose = onClickPurchaseErrorModalClose;
exports.goToAllProducts = goToAllProducts;
exports.goToManagePurchases = goToManagePurchases;
exports.getGoodDetails = getGoodDetails;
exports.hideAutocompleteMenu = hideAutocompleteMenu;
exports.fetchForAutocomplete = fetchForAutocomplete;
exports.getGoodsWithFilterAndPageParamsFromUrl = getGoodsWithFilterAndPageParamsFromUrl;
exports.purchaseGoodWithPaypal = purchaseGoodWithPaypal;
exports.purchaseGoodWithStripe = purchaseGoodWithStripe;
exports.handleRedirectFromPaypal = handleRedirectFromPaypal;
exports.triggerPurchaseErrorModalOpening = triggerPurchaseErrorModalOpening;
exports.updatePage = updatePage;
exports.updateGoodFilters = updateGoodFilters;
exports.fetchMatchingSearchResults = fetchMatchingSearchResults;
exports.goToGoodSearchOption = goToGoodSearchOption;
exports.getPurchasedGoods = getPurchasedGoods;
exports.closePaypalPurchaseDelayErrorAlert = closePaypalPurchaseDelayErrorAlert;
exports.closeReviewModal = closeReviewModal;
exports.closeCreateNewAssetModal = closeCreateNewAssetModal;
exports.closeCreateWebpageModal = closeCreateWebpageModal;
exports.closeCheckGoodUsageErrorAlert = closeCheckGoodUsageErrorAlert;
exports.closePurchasedGoodActionsMenu = closePurchasedGoodActionsMenu;
exports.closePurchaseDetails = closePurchaseDetails;
exports.closeReinstallationErrorAlert = closeReinstallationErrorAlert;
exports.openPurchasedGoodActionsMenu = openPurchasedGoodActionsMenu;
exports.openPurchaseDetails = openPurchaseDetails;
exports.triggerReviewModal = triggerReviewModal;
exports.openCreateWebpageModal = openCreateWebpageModal;
exports.openCreateNewAssetModal = openCreateNewAssetModal;
exports.submitReview = submitReview;
exports.closeRefundModal = closeRefundModal;
exports.closeUninstallConfirmModal = closeUninstallConfirmModal;
exports.closeUninstallModal = closeUninstallModal;
exports.triggerRefundOrUninstallModal = triggerRefundOrUninstallModal;
exports.triggerConfirmOrUninstallModal = triggerConfirmOrUninstallModal;
exports.checkGoodUsage = checkGoodUsage;
exports.triggerSeeWhereInUseModal = triggerSeeWhereInUseModal;
exports.submitRefund = submitRefund;
exports.updateRefund = updateRefund;
exports.trackMultiselectSelection = trackMultiselectSelection;
exports.pollGoodDeliveryStatus = pollGoodDeliveryStatus;
exports.onClickInstallStatusModalClose = onClickInstallStatusModalClose;
exports.goToGoodDetails = goToGoodDetails;
exports.getProviderNames = getProviderNames;
exports.createAsset = createAsset;
exports.togglePurchasedPack = togglePurchasedPack;
exports.reinstallGood = reinstallGood;
exports.uninstallGood = uninstallGood;
exports.trackGoodInfo = trackGoodInfo;
exports.navigateFromGoodDetailsReview = navigateFromGoodDetailsReview;
exports.resetGoodDetails = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactRouter = require("react-router");

var _reactRouterRedux = require("react-router-redux");

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _Raven = _interopRequireDefault(require("Raven"));

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _CheckGoodUsageErrorTypes = _interopRequireDefault(require("../constants/CheckGoodUsageErrorTypes"));

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var _CosIndexClient = _interopRequireDefault(require("../data/CosIndexClient"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _GoodSubTypePythonFieldNames = _interopRequireDefault(require("../constants/GoodSubTypePythonFieldNames"));

var _ManagePurchasesColumns = _interopRequireDefault(require("../constants/ManagePurchasesColumns"));

var _DetailsPanelItems = _interopRequireDefault(require("../constants/DetailsPanelItems"));

var _PaymentMethods = _interopRequireDefault(require("../constants/PaymentMethods"));

var _PayPalPurchaseErrors = _interopRequireWildcard(require("../constants/PayPalPurchaseErrors"));

var _StripePurchaseErrors = _interopRequireDefault(require("../constants/StripePurchaseErrors"));

var _InitialFilterParams = _interopRequireDefault(require("../constants/InitialFilterParams"));

var _ProductMarketplaceClient = _interopRequireDefault(require("../data/ProductMarketplaceClient"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _SortOptions = _interopRequireDefault(require("../constants/SortOptions"));

var _UninstallModalTypes = _interopRequireDefault(require("../constants/UninstallModalTypes"));

var UrlPathParams = _interopRequireWildcard(require("../constants/UrlPathParams"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _Limits = require("../constants/Limits");

var _RefundStatusTypes = require("marketplace-lib/constants/RefundStatusTypes");

var _utils = require("../utils/utils");

var _utils2 = require("../utils/managePurchases/utils");

var _auth = require("../selectors/auth");

var _usageTrackerRedux = require("usage-tracker-redux");

var _constants = require("../lib/usage/constants");

var _earlyRequests = require("../utils/earlyRequests");

function _getGoodDetails(error) {
  if (error) {
    return {
      type: _ActionTypes.default.GOOD_DETAILS_REQUESTED,
      payload: error,
      error: true
    };
  }

  return {
    type: _ActionTypes.default.GOOD_DETAILS_REQUESTED
  };
}

function goodsRequestedOnPageLoad(error) {
  if (error) {
    return {
      type: _ActionTypes.default.GOODS_REQUESTED_ON_PAGE_LOAD,
      payload: error,
      error: true
    };
  }

  return {
    type: _ActionTypes.default.GOODS_REQUESTED_ON_PAGE_LOAD
  };
}

function _purchaseGoodWithPaypal(error) {
  if (error) {
    return {
      type: _ActionTypes.default.PURCHASED_WITH_PAYPAL,
      payload: error,
      error: true
    };
  }

  return {
    type: _ActionTypes.default.PURCHASED_WITH_PAYPAL
  };
}

function _purchaseGoodWithStripe(goodId, error) {
  if (error) {
    return {
      type: _ActionTypes.default.PURCHASED_WITH_STRIPE,
      payload: error,
      error: true
    };
  }

  return {
    type: _ActionTypes.default.PURCHASED_WITH_STRIPE,
    payload: goodId
  };
}

function paypalPurchaseCompleted(goodId) {
  return {
    type: _ActionTypes.default.PAYPAL_PURCHASE_COMPLETED,
    payload: {
      goodId: goodId
    }
  };
}

function _updateGoodFiltersOrPage(newParams, screen) {
  var params = (0, _immutable.Map)(newParams);
  return {
    type: _ActionTypes.default.FILTERS_OR_PAGE_UPDATED,
    payload: params,
    meta: {
      screen: screen
    }
  };
}

function onClickPurchaseErrorModalClose() {
  return {
    type: _ActionTypes.default.DISMISSED_PURCHASE_ERROR
  };
}

function receiveGoodDetails(response) {
  return {
    type: _ActionTypes.default.GOOD_DETAILS_RECEIVED,
    payload: response
  };
}

function receiveGoods(response) {
  return {
    type: _ActionTypes.default.GOODS_RECEIVED,
    payload: response
  };
}

function stripePurchaseCompleted() {
  return {
    type: _ActionTypes.default.STRIPE_PURCHASE_COMPLETED
  };
}

function updateGoodFiltersOrPage(filterAndPageParams, dispatch, getState, screen) {
  dispatch(_updateGoodFiltersOrPage(filterAndPageParams, screen));
  var updatedFilteringAndPageParams = (0, _utils.mergeGoodFiltersAndPage)(getState().directoryData.get('goodFiltersAndPage'), filterAndPageParams);
  dispatch((0, _reactRouterRedux.push)((0, _utils.getUrlWithNonInitialFiltersAndPageShown)(updatedFilteringAndPageParams)));
}

function goToAllProducts() {
  return function (dispatch) {
    dispatch((0, _reactRouterRedux.push)('products'));
  };
}

function goToManagePurchases() {
  return function (dispatch) {
    dispatch((0, _reactRouterRedux.push)('/manage-purchases'));
  };
}

function getGoodDetails(providerUrlToken, goodNameUrlToken, previewMode, isCustomerBool) {
  return function (dispatch) {
    dispatch(_getGoodDetails());

    _ProductMarketplaceClient.default.getGoodDetails(providerUrlToken, goodNameUrlToken, previewMode, isCustomerBool).then(function (response) {
      dispatch(receiveGoodDetails(response));
    }, function (error) {
      _Raven.default.captureMessage('ERROR_API_GOOD_DETAILS', {
        level: 'error',
        extra: {
          error: error,
          providerUrlToken: providerUrlToken,
          goodNameUrlToken: goodNameUrlToken
        }
      });

      if (error.status === 404) {
        dispatch((0, _reactRouterRedux.replace)('/products'));
      } else {
        dispatch(_getGoodDetails(new Error(error)));
      }
    }).done();
  };
}

function hideAutocompleteMenu() {
  return {
    type: _ActionTypes.default.HIDE_AUTOCOMPLETE_MENU
  };
}

function updateAutocompleteMenu(result) {
  return {
    type: _ActionTypes.default.UPDATE_AUTOCOMPLETE_MENU,
    payload: result
  };
}

function fetchForAutocomplete(searchTerm) {
  return function (dispatch, getState) {
    var _currentFilters$merge;

    if (!searchTerm) {
      dispatch(updateAutocompleteMenu([]));
      return;
    }

    var currentFilters = getState().directoryData.get('goodFiltersAndPage');

    _ProductMarketplaceClient.default.getGoods(currentFilters.merge((_currentFilters$merge = {}, (0, _defineProperty2.default)(_currentFilters$merge, _GoodFiltersAndPage.default.SEARCH_TERM, searchTerm), (0, _defineProperty2.default)(_currentFilters$merge, _GoodFiltersAndPage.default.PAGE, 0), (0, _defineProperty2.default)(_currentFilters$merge, _GoodFiltersAndPage.default.SORT_BY, _SortOptions.default.MOST_DOWNLOADED), (0, _defineProperty2.default)(_currentFilters$merge, _GoodFiltersAndPage.default.LIMIT, _Limits.ITEMS_PER_ROW), _currentFilters$merge)), (0, _utils.isCustomer)(getState().auth.portal)).then(function (resp) {
      dispatch(updateAutocompleteMenu(resp.result));
    }, function () {// TODO: decide how to handle errors during update
    }).done();
  };
}

function getGoodsWithFilterAndPageParamsFromUrl(filterAndPageParams, navigatedToDirectoryPage, earlyRequestName) {
  return function (dispatch, getState) {
    var mergedFilterParams = _InitialFilterParams.default.merge(filterAndPageParams);

    if (navigatedToDirectoryPage) {
      dispatch(goodsRequestedOnPageLoad());
    }

    dispatch(_updateGoodFiltersOrPage(mergedFilterParams, null));
    (0, _earlyRequests.maybeEarlyRequest)(earlyRequestName, function () {
      return _ProductMarketplaceClient.default.getGoods(mergedFilterParams, (0, _utils.isCustomer)(getState().auth.portal));
    }).then(function (response) {
      dispatch(receiveGoods(response));
    }, function (error) {
      if (navigatedToDirectoryPage) {
        dispatch(goodsRequestedOnPageLoad(new Error(error)));
      } // TODO: decide how to handle errors during update

    }).done();
  };
}

function purchaseGoodWithPaypal(data) {
  return function (dispatch) {
    dispatch(_purchaseGoodWithPaypal());

    _ProductMarketplaceClient.default.purchaseGood(_PaymentMethods.default.PAYPAL, data).then(function (resp) {
      if (resp.redirectUrl) {
        window.location = resp.redirectUrl;
      } else {
        dispatch(_purchaseGoodWithPaypal(new Error(_PayPalPurchaseErrors.default.PAYPAL_PURCHASE_FAILED)));

        _Raven.default.captureMessage('missing paypal redirect-url');
      }
    }, function (error) {
      var errorMsg = _PayPalPurchaseErrors.default.PAYPAL_PURCHASE_FAILED;

      try {
        var respText = error.responseJSON.message;

        if (respText && (0, _PayPalPurchaseErrors.isProviderError)(respText)) {
          errorMsg = _PayPalPurchaseErrors.default.PROVIDER_ERROR;
        }
      } catch (e) {
        _Raven.default.captureMessage('error parsing paypal purchase error', {
          paypalError: e
        });
      }

      dispatch(_purchaseGoodWithPaypal(new Error(errorMsg)));
    }).done();
  };
}

function purchaseGoodWithStripe(data) {
  return function (dispatch) {
    dispatch(_purchaseGoodWithStripe(data.goodId));

    _ProductMarketplaceClient.default.purchaseGood(_PaymentMethods.default.STRIPE, data).then(function () {
      dispatch(stripePurchaseCompleted());
      dispatch((0, _reactRouterRedux.push)('manage-purchases'));
    }, function (error) {
      var errorMsg = 'unknown error';

      try {
        var respText = JSON.parse(error.xhr.responseText);

        if (respText && respText.message) {
          errorMsg = respText.message;
        }
      } catch (e) {
        _Raven.default.captureMessage("error parsing stripe purchase error: " + e);
      }

      dispatch(_purchaseGoodWithStripe(null, new Error(errorMsg)));
    }).done();
  };
}

function receivePurchasedGoods(goodsInResponse) {
  var purchasedGoodsDisplayOrder = [];
  var purchasedGoods = {};
  goodsInResponse.forEach(function (good) {
    var _purchasedGoods$goodI;

    var goodId = good.goodDetails.goodInfo.goodId.toString();
    purchasedGoodsDisplayOrder.push(goodId);
    var packChildrenDisplayOrder = [];

    if (good.goodDetails.children) {
      good.goodDetails.children.forEach(function (child) {
        var _purchasedGoods$gener;

        var childGoodId = child.goodId.toString();
        packChildrenDisplayOrder.push(childGoodId);
        purchasedGoods[(0, _utils2.generatePurchasedGoodsKeyForChildGood)({
          childId: childGoodId,
          parentId: goodId
        })] = (_purchasedGoods$gener = {
          goodId: childGoodId,
          parentId: goodId,
          urlToken: child.urlToken,
          goodVersionId: child.goodVersionId,
          templatePath: (0, _utils2.getChildTemplatePath)(good.deliverDetails.goodDeliverInfo, child),
          destinationId: (0, _utils2.getChildDestinationId)(good.deliverDetails.goodDeliverInfo, child)
        }, (0, _defineProperty2.default)(_purchasedGoods$gener, _ManagePurchasesColumns.default.IMAGE, child.images.MARKETING_IMAGE_SMALL), (0, _defineProperty2.default)(_purchasedGoods$gener, _ManagePurchasesColumns.default.PRODUCT_NAME, (0, _utils.getEnglishTextFieldFromGoodTextObj)('NAME', child.texts)), (0, _defineProperty2.default)(_purchasedGoods$gener, _ManagePurchasesColumns.default.PRODUCT_TYPE, child.subType), (0, _defineProperty2.default)(_purchasedGoods$gener, _ManagePurchasesColumns.default.PURCHASE_DATE, good.transaction.createdAt), (0, _defineProperty2.default)(_purchasedGoods$gener, _DetailsPanelItems.default.CREATED_BY, good.goodDetails.providerInfo.company), (0, _defineProperty2.default)(_purchasedGoods$gener, _DetailsPanelItems.default.TRANSACTION_ID, good.transaction.id), (0, _defineProperty2.default)(_purchasedGoods$gener, _DetailsPanelItems.default.DOCUMENTATION_LINK, child.documentationLink), (0, _defineProperty2.default)(_purchasedGoods$gener, _DetailsPanelItems.default.EXAMPLE_LINK, child.exampleLink), (0, _defineProperty2.default)(_purchasedGoods$gener, _DetailsPanelItems.default.PROVIDER_WEBSITE, good.goodDetails.providerInfo.website), (0, _defineProperty2.default)(_purchasedGoods$gener, _DetailsPanelItems.default.PROVIDER_EMAIL, good.goodDetails.providerInfo.supportEmail || good.goodDetails.providerInfo.contactEmail), (0, _defineProperty2.default)(_purchasedGoods$gener, _DetailsPanelItems.default.REVIEW, child.review), _purchasedGoods$gener);
      });
    }

    purchasedGoods[goodId] = (_purchasedGoods$goodI = {
      goodId: goodId,
      urlToken: good.goodDetails.goodInfo.urlToken,
      deliveryStatus: good.deliverDetails.status,
      deliveryErrorMessage: good.deliverDetails.error,
      templatePath: (0, _utils2.getTemplatePathForGoodNotInPack)(good.deliverDetails.goodDeliverInfo),
      destinationId: (0, _utils2.getDestinationIdForGoodNotInPack)(good.deliverDetails.goodDeliverInfo),
      newVersionAvailable: good.goodDetails.newVersionAvailable
    }, (0, _defineProperty2.default)(_purchasedGoods$goodI, _ManagePurchasesColumns.default.IMAGE, good.goodDetails.goodInfo.goodImages.MARKETING_IMAGE_SMALL), (0, _defineProperty2.default)(_purchasedGoods$goodI, _ManagePurchasesColumns.default.PRODUCT_NAME, (0, _utils.getEnglishTextFieldFromGoodTextObj)('NAME', good.goodDetails.goodInfo.goodText)), (0, _defineProperty2.default)(_purchasedGoods$goodI, _ManagePurchasesColumns.default.PRODUCT_TYPE, good.goodDetails.goodInfo.subType), (0, _defineProperty2.default)(_purchasedGoods$goodI, _ManagePurchasesColumns.default.PURCHASE_DATE, good.transaction.createdAt), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.BUYER_EMAIL, good.transaction.buyerEmail), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.CREATED_BY, good.goodDetails.providerInfo.company), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.IS_FREE, good.goodDetails.goodInfo.free), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.PRICE, good.transaction.price), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.PAYMENT_TYPE, good.transaction.paymentType), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.TRANSACTION_ID, good.transaction.id), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.DOCUMENTATION_LINK, good.goodDetails.goodInfo.documentationLink), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.EXAMPLE_LINK, good.goodDetails.goodInfo.exampleLink), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.PROVIDER_WEBSITE, good.goodDetails.providerInfo.website), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.PROVIDER_EMAIL, good.goodDetails.providerInfo.supportEmail || good.goodDetails.providerInfo.contactEmail), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.REFUND_REQUESTED_DATE, good.transaction.refundRequestedDate), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.REFUND, good.transaction.refund), (0, _defineProperty2.default)(_purchasedGoods$goodI, _DetailsPanelItems.default.REVIEW, good.review), (0, _defineProperty2.default)(_purchasedGoods$goodI, "packChildrenDisplayOrder", packChildrenDisplayOrder), (0, _defineProperty2.default)(_purchasedGoods$goodI, "totalChildren", good.goodDetails.totalChildren), (0, _defineProperty2.default)(_purchasedGoods$goodI, "showChildren", false), _purchasedGoods$goodI);
  });
  return {
    type: _ActionTypes.default.PURCHASED_GOODS_RECEIVED,
    payload: {
      purchasedGoodsDisplayOrder: purchasedGoodsDisplayOrder,
      purchasedGoods: purchasedGoods
    }
  };
}

function _getPurchasedGoods(error) {
  if (error) {
    return {
      type: _ActionTypes.default.PURCHASED_GOODS_REQUESTED,
      payload: error,
      error: true
    };
  }

  return {
    type: _ActionTypes.default.PURCHASED_GOODS_REQUESTED
  };
}

function trackPurchaseWithPaypal(auth, paymentAmount, subType) {
  return _usageTrackerRedux.usageTrackerActions.track(_constants.EventTypes.PURCHASED_GOOD, {
    screen: _constants.Screens.DETAILS,
    value: paymentAmount,
    value_str: subType,
    payment_type: 'paypal',
    is_trial: (0, _utils.isCustomer)(auth.portal) && (0, _utils.isTrialPortal)(auth.portal)
  });
}

function handleRedirectFromPaypal(_ref) {
  var goodId = _ref.goodId,
      _ref$paymentAmount = _ref.paymentAmount,
      paymentAmount = _ref$paymentAmount === void 0 ? 0 : _ref$paymentAmount,
      _ref$subType = _ref.subType,
      subType = _ref$subType === void 0 ? '' : _ref$subType;
  return function (dispatch, getState) {
    dispatch(trackPurchaseWithPaypal(getState().auth, Number(paymentAmount), subType));
    dispatch((0, _reactRouterRedux.push)('/manage-purchases'));
    dispatch(paypalPurchaseCompleted(goodId));
  };
}

function triggerPurchaseErrorModalOpening(errorMsg) {
  return function (dispatch) {
    if (errorMsg === _StripePurchaseErrors.default.STRIPE_CHECKOUT_FAILED) {
      dispatch(_purchaseGoodWithStripe(null, new Error(errorMsg)));
    }
  };
}

function updatePage(page) {
  return function (dispatch, getState) {
    updateGoodFiltersOrPage({
      page: page
    }, dispatch, getState);
  };
}

function updateGoodFilters(newFilteringParams) {
  return function (dispatch, getState) {
    updateGoodFiltersOrPage(newFilteringParams, dispatch, getState);
  };
}

function fetchMatchingSearchResults(searchTermAndResetFilterParams, screen) {
  return function (dispatch, getState) {
    dispatch(hideAutocompleteMenu());
    updateGoodFiltersOrPage(searchTermAndResetFilterParams, dispatch, getState, screen);
  };
}

function goToGoodSearchOption(goodUrlToken, screen) {
  return function (dispatch) {
    dispatch(hideAutocompleteMenu());
    dispatch((0, _reactRouterRedux.push)("/" + UrlPathParams.DIRECTORY_PAGE_PATH + "/" + goodUrlToken));
    dispatch(_usageTrackerRedux.usageTrackerActions.track(_constants.EventTypes.SELECTED_SEARCH_OPTION, {
      screen: screen,
      value_str: goodUrlToken
    }));
  };
}

function getPurchasedGoods() {
  return function (dispatch) {
    dispatch(_getPurchasedGoods());

    _ProductMarketplaceClient.default.getPurchasedGoods().then(function (goods) {
      dispatch(receivePurchasedGoods(goods));
    }, function (error) {
      dispatch(_getPurchasedGoods(new Error(error)));
    }).done();
  };
}

function _submitReview(error) {
  if (error) {
    return {
      type: _ActionTypes.default.REVIEW_SUBMITTED,
      payload: error,
      error: true
    };
  }

  return {
    type: _ActionTypes.default.REVIEW_SUBMITTED
  };
}

function closePaypalPurchaseDelayErrorAlert() {
  return {
    type: _ActionTypes.default.PAYPAL_DELAY_ERROR_ALERT_DISMISSED
  };
}

function closeReviewModal() {
  return {
    type: _ActionTypes.default.DISMISSED_REVIEW_MODAL
  };
}

function closeCreateNewAssetModal() {
  return {
    type: _ActionTypes.default.CREATE_NEW_ASSET_MODAL_DISMISSED
  };
}

function closeCreateWebpageModal() {
  return {
    type: _ActionTypes.default.CREATE_WEBPAGE_MODAL_DISMISSED
  };
}

function closeCheckGoodUsageErrorAlert(errorId) {
  return {
    type: _ActionTypes.default.CHECK_GOOD_USAGE_ERROR_ALERT_DISMISSED,
    payload: {
      errorId: errorId
    }
  };
}

function closePurchasedGoodActionsMenu() {
  return {
    type: _ActionTypes.default.PURCHASE_ACTIONS_MENU_CLOSED
  };
}

function closePurchaseDetails() {
  return {
    type: _ActionTypes.default.PURCHASE_DETAILS_CLOSED
  };
}

function closeReinstallationErrorAlert() {
  return {
    type: _ActionTypes.default.DISMISSED_REINSTALLATION_ERROR_ALERT
  };
}

function openPurchasedGoodActionsMenu(purchasedGoodsKey) {
  return {
    type: _ActionTypes.default.PURCHASE_ACTIONS_MENU_OPENED,
    payload: {
      purchasedGoodsKey: purchasedGoodsKey
    }
  };
}

function openPurchaseDetails(purchasedGoodsKey) {
  return {
    type: _ActionTypes.default.PURCHASE_DETAILS_OPENED,
    payload: {
      purchasedGoodsKey: purchasedGoodsKey
    }
  };
}

function triggerReviewModal(goodId, goodName, transactionId, parentId) {
  return {
    type: _ActionTypes.default.REVIEW_MODAL_OPENED,
    payload: {
      goodId: goodId,
      goodName: goodName,
      transactionId: transactionId,
      parentId: parentId
    }
  };
}

function openCreateWebpageModal() {
  return {
    type: _ActionTypes.default.CREATE_WEBPAGE_MODAL_OPENED
  };
}

function openCreateNewAssetModal(good) {
  return {
    type: _ActionTypes.default.CREATE_NEW_ASSET_MODAL_OPENED,
    payload: {
      good: good
    }
  };
}

function submitReviewFromDetailsSuccess(goodId, review) {
  return {
    type: _ActionTypes.default.REVIEW_SUBMITTED_FROM_DETAILS_SUCCESS,
    payload: {
      goodId: goodId,
      review: review
    }
  };
}

function submitReviewFromPurchasesSuccess(purchasedGoodsKey, review) {
  return {
    type: _ActionTypes.default.REVIEW_SUBMITTED_FROM_PURCHASES_SUCCESS,
    payload: {
      purchasedGoodsKey: purchasedGoodsKey,
      review: review
    }
  };
}

function submitReview(goodId, transactionId, rating, reviewText, pageOpenedFrom, parentId) {
  return function (dispatch) {
    dispatch(_submitReview());

    _ProductMarketplaceClient.default.submitReview(goodId, transactionId, rating, reviewText).then(function (review) {
      if (pageOpenedFrom === 'details') {
        dispatch(submitReviewFromDetailsSuccess(goodId, review));
        return;
      }

      dispatch(submitReviewFromPurchasesSuccess(parentId ? (0, _utils2.generatePurchasedGoodsKeyForChildGood)({
        childId: goodId,
        parentId: parentId
      }) : goodId, review));
    }, function (error) {
      dispatch(_submitReview(new Error(error)));
    }).done();
  };
}

function _submitRefund(error) {
  if (error) {
    return {
      type: _ActionTypes.default.REFUND_SUBMITTED,
      payload: error,
      error: true
    };
  }

  return {
    type: _ActionTypes.default.REFUND_SUBMITTED
  };
}

function _submitRefundSuccess() {
  return {
    type: _ActionTypes.default.REFUND_SUBMITTED_SUCCESS
  };
}

function _cancelRefundSuccess(goodId) {
  return {
    type: _ActionTypes.default.REFUND_CANCEL_SUCCESS,
    payload: goodId
  };
}

function _updateRefund(error) {
  if (error) {
    return {
      type: _ActionTypes.default.REFUND_UPDATED,
      payload: error,
      error: true
    };
  }

  return {
    type: _ActionTypes.default.REFUND_UPDATED
  };
}

function _updateRefundSuccess(refund, goodId) {
  return {
    type: _ActionTypes.default.REFUND_UPDATE_SUCCESS,
    payload: {
      refund: refund,
      goodId: goodId
    }
  };
}

function closeRefundModal() {
  return {
    type: _ActionTypes.default.DISMISSED_REFUND_MODAL
  };
}

function closeUninstallConfirmModal() {
  return {
    type: _ActionTypes.default.DISMISSED_UNINSTALL_CONFIRM_MODAL
  };
}

function closeUninstallModal() {
  return {
    type: _ActionTypes.default.DISMISSED_UNINSTALL_MODAL
  };
}

function showRefundModal(goodToRefund) {
  return {
    type: _ActionTypes.default.REFUND_MODAL_OPENED,
    payload: goodToRefund
  };
}

function showUninstallModal(_ref2) {
  var modalType = _ref2.modalType,
      good = _ref2.good,
      assetsWhereGoodInUse = _ref2.assetsWhereGoodInUse,
      packChildrenInUse = _ref2.packChildrenInUse;
  return {
    type: _ActionTypes.default.SHOW_UNINSTALL_MODAL,
    payload: {
      modalType: modalType,
      goodName: good.get('name'),
      goodSubtype: good.get('subType'),
      assetsWhereGoodInUse: assetsWhereGoodInUse,
      packChildrenInUse: packChildrenInUse
    }
  };
}

function checkPackChildUsageAndTriggerModal(goodToRefund, purchasedGoods, dispatch) {
  _CosIndexClient.default.checkPackChildUsage((0, _utils2.getPackChildrenDestinationIds)(goodToRefund, purchasedGoods)).then(function (response) {
    var childrenInUseDestinationIds = (0, _utils2.getPackChildrenInUseDestinationIds)(response);

    if (!childrenInUseDestinationIds.size) {
      dispatch(showRefundModal(goodToRefund));
      return;
    }

    dispatch(showUninstallModal({
      modalType: _UninstallModalTypes.default.ATTEMPTED_REFUND_PACK,
      good: goodToRefund,
      assetsWhereGoodInUse: [],
      packChildrenInUse: (0, _utils2.getPackChildrenInUse)(childrenInUseDestinationIds, goodToRefund, purchasedGoods)
    }));
    return;
  }, function () {
    dispatch(showRefundModal(goodToRefund));
  }).done();
}

function checkGoodUsageAndTriggerModal(goodToRefund, dispatch) {
  _CosIndexClient.default.checkGoodUsage(goodToRefund.get('destinationId')).then(function (response) {
    if (!response.length) {
      dispatch(showRefundModal(goodToRefund));
      return;
    }

    dispatch(showUninstallModal({
      modalType: _UninstallModalTypes.default.ATTEMPTED_REFUND_INDIVIDUAL,
      good: goodToRefund,
      assetsWhereGoodInUse: response,
      packChildrenInUse: []
    }));
    return;
  }, function () {
    dispatch(showRefundModal(goodToRefund));
  }).done();
}

function _checkGoodUsage(error, errorType, good) {
  if (error) {
    var goodId = good ? good.get('goodId') : '';
    return {
      type: _ActionTypes.default.CHECK_GOOD_USAGE,
      payload: {
        errorId: errorType + "-" + goodId,
        errorType: errorType,
        good: good
      },
      error: true
    };
  }

  return {
    type: _ActionTypes.default.CHECK_GOOD_USAGE
  };
}

function triggerRefundOrUninstallModal(goodToRefund) {
  return function (dispatch, getState) {
    dispatch(_checkGoodUsage());

    if (goodToRefund.get('totalChildren')) {
      checkPackChildUsageAndTriggerModal(goodToRefund, getState().managePurchases.get('purchasedGoods'), dispatch);
      return;
    }

    checkGoodUsageAndTriggerModal(goodToRefund, dispatch);
  };
}

function showUninstallConfirmModal(goodToUninstall) {
  return {
    type: _ActionTypes.default.SHOW_UNINSTALL_CONFIRM_MODAL,
    payload: goodToUninstall
  };
}

function triggerConfirmOrUninstallModalForTemplates(goodToUninstall, dispatch) {
  _CosIndexClient.default.checkGoodUsage(goodToUninstall.get('destinationId')).then(function (response) {
    if (!response.length) {
      dispatch(showUninstallConfirmModal(goodToUninstall));
      return;
    }

    dispatch(showUninstallModal({
      modalType: _UninstallModalTypes.default.ATTEMPTED_UNINSTALL_INDIVIDUAL,
      good: goodToUninstall,
      assetsWhereGoodInUse: response,
      packChildrenInUse: []
    }));
    return;
  }, function (error) {
    dispatch(_checkGoodUsage(new Error(error), _CheckGoodUsageErrorTypes.default.ATTEMPTED_UNINSTALL, goodToUninstall));
  }).done();
}

function triggerConfirmOrUninstallModalForPacks(goodToUninstall, purchasedGoods, dispatch) {
  _CosIndexClient.default.checkPackChildUsage((0, _utils2.getPackChildrenDestinationIds)(goodToUninstall, purchasedGoods)).then(function (response) {
    var childrenInUseDestinationIds = (0, _utils2.getPackChildrenInUseDestinationIds)(response);

    if (!childrenInUseDestinationIds.size) {
      dispatch(showUninstallConfirmModal(goodToUninstall));
      return;
    }

    dispatch(showUninstallModal({
      modalType: _UninstallModalTypes.default.ATTEMPTED_UNINSTALL_PACK,
      good: goodToUninstall,
      assetsWhereGoodInUse: [],
      packChildrenInUse: (0, _utils2.getPackChildrenInUse)(childrenInUseDestinationIds, goodToUninstall, purchasedGoods)
    }));
    return;
  }, function (error) {
    dispatch(_checkGoodUsage(new Error(error), _CheckGoodUsageErrorTypes.default.ATTEMPTED_UNINSTALL, goodToUninstall));
  }).done();
}

function triggerConfirmOrUninstallModal(goodToUninstall) {
  return function (dispatch, getState) {
    dispatch(_checkGoodUsage());

    if (goodToUninstall.get('totalChildren')) {
      triggerConfirmOrUninstallModalForPacks(goodToUninstall, getState().managePurchases.get('purchasedGoods'), dispatch);
      return;
    }

    triggerConfirmOrUninstallModalForTemplates(goodToUninstall, dispatch);
  };
}

function goodUsageInfoReceived(good, response) {
  return {
    type: _ActionTypes.default.GOOD_USAGE_INFO_RECEIVED,
    payload: {
      assetsWhereGoodInUse: response,
      purchasedGoodsKey: !good.get('parentId') ? good.get('goodId') : (0, _utils2.generatePurchasedGoodsKeyForChildGood)({
        childId: good.get('goodId'),
        parentId: good.get('parentId')
      })
    }
  };
}

function checkGoodUsage(good) {
  return function (dispatch) {
    _CosIndexClient.default.checkGoodUsage(good.get('destinationId')).then(function (response) {
      dispatch(goodUsageInfoReceived(good, response));
      return;
    }, function (error) {
      dispatch(_checkGoodUsage(new Error(error), _CheckGoodUsageErrorTypes.default.OPENED_DROPDOWN, good));
    }).done();
  };
}

function triggerSeeWhereInUseModal(good) {
  return function (dispatch) {
    dispatch(showUninstallModal({
      modalType: _UninstallModalTypes.default.SEE_WHERE_IN_USE,
      good: good,
      assetsWhereGoodInUse: good.get('assetsWhereGoodInUse'),
      packChildrenInUse: []
    }));
  };
}

function submitRefund(transactionId, reason) {
  return function (dispatch) {
    dispatch(_submitRefund());

    _ProductMarketplaceClient.default.submitRefund(transactionId, reason).then(function (response) {
      dispatch(_submitRefundSuccess());
      dispatch(receivePurchasedGoods(response));
    }, function (error) {
      dispatch(_submitRefund(error));
    }).done();
  };
}

function updateRefund(transactionId, status, reason, goodId) {
  return function (dispatch) {
    dispatch(_updateRefund());

    _ProductMarketplaceClient.default.updateRefund(transactionId, status, reason).then(function (response) {
      dispatch(_updateRefundSuccess(response, goodId)); // If they submitted reason, they're requesting
      // a refund after cancelling a previous one.
      // Dispatching submitRefundSuccess
      // handles the refundModal state

      if (reason) {
        dispatch(_submitRefundSuccess());
      } // If they're canceling a refund, we want to update
      // the delivery status from "REFUNDED" to "UNINSTALLED."
      // Dispatching cancelRefundSuccess handles this.


      if (status === _RefundStatusTypes.CANCELED) {
        dispatch(_cancelRefundSuccess(goodId));
      }
    }, function (error) {
      if (reason) {
        dispatch(_submitRefund(error));
      }

      dispatch(_updateRefund(error));
    }).done();
  };
}

function trackMultiselectSelection(adjustedFilter, selection) {
  return {
    type: _ActionTypes.default.TRACK_MULTISELECT_SELECTION,
    payload: {
      adjustedFilter: adjustedFilter,
      selection: selection
    }
  };
}

function receivePollingGoodInfo(goodId, goodStatus, goodDeliverInfo) {
  return {
    type: _ActionTypes.default.POLLING_GOOD_INFO_RECEIVED,
    payload: {
      goodId: goodId,
      goodStatus: goodStatus,
      goodDeliverInfo: goodDeliverInfo
    }
  };
}

function displaySlowDeliveryMessage(goodId) {
  return {
    type: _ActionTypes.default.OPEN_SLOW_DELIVERY_MODAL,
    payload: {
      goodId: goodId
    }
  };
}

function pollGoodDeliveryStatus(goodId) {
  var elapsedSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return function (dispatch) {
    _ProductMarketplaceClient.default.getDeliverStatus(goodId).then(function (data) {
      if (data.status === _RequestStatusTypes.default.SUCCEEDED) {
        dispatch(receivePollingGoodInfo(goodId, _RequestStatusTypes.default.SUCCEEDED, data.goodDeliverInfo));
      } else if (data.status === _RequestStatusTypes.default.PENDING) {
        dispatch(receivePollingGoodInfo(goodId, _RequestStatusTypes.default.PENDING, []));

        if ((0, _utils.hasFifteenMinutesElapsed)(elapsedSeconds)) {
          dispatch(displaySlowDeliveryMessage(goodId));
        }

        setTimeout(function () {
          return dispatch(pollGoodDeliveryStatus(goodId, (0, _utils.getSecondsElapsedBeforeNextPolling)(elapsedSeconds)));
        }, (0, _utils.getPollIntervalInMilliseconds)(elapsedSeconds));
      }
    }, function () {
      dispatch(receivePollingGoodInfo(goodId, _RequestStatusTypes.default.FAILED));
    }).done();
  };
}

function onClickInstallStatusModalClose() {
  return {
    type: _ActionTypes.default.DISMISSED_INSTALL_STATUS_MODAL
  };
}

function goToGoodDetails(goodUrlToken) {
  return function (dispatch) {
    dispatch((0, _reactRouterRedux.push)(UrlPathParams.DIRECTORY_PAGE_PATH + "/" + goodUrlToken));
  };
}

function getProviderNames() {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.default.PROVIDER_NAMES_REQUESTED
    });

    _ProductMarketplaceClient.default.getProviderNames().then(function (payload) {
      dispatch({
        type: _ActionTypes.default.PROVIDER_NAMES_RECEIVED,
        payload: payload
      });
    }, function (error) {
      dispatch({
        type: _ActionTypes.default.PROVIDER_NAMES_FAILED,
        error: true,
        payload: error
      });
    }).done();
  };
}

function _createAsset(purchasedGoodsKey, error) {
  if (error) {
    return {
      type: _ActionTypes.default.CREATE_ASSET,
      payload: {
        error: error,
        purchasedGoodsKey: purchasedGoodsKey
      },
      error: true
    };
  }

  return {
    type: _ActionTypes.default.CREATE_ASSET,
    payload: {
      purchasedGoodsKey: purchasedGoodsKey
    }
  };
}

function createAsset(_ref3) {
  var subType = _ref3.subType,
      name = _ref3.name,
      templatePath = _ref3.templatePath,
      purchasedGoodsKey = _ref3.purchasedGoodsKey;
  return function (dispatch, getState) {
    var state = getState();
    var hasSitePagesAccess = (0, _auth.getHasSitePagesAccess)(state);
    dispatch(_createAsset(purchasedGoodsKey));
    var createAssetRequest;

    if (subType === _GoodSubTypes.default.EMAIL_TEMPLATES) {
      createAssetRequest = _ProductMarketplaceClient.default.createEmailAsset(name, templatePath);
    } else {
      createAssetRequest = _ProductMarketplaceClient.default.createPageAsset(name, templatePath, subType === _GoodSubTypes.default.SITE_PAGES && hasSitePagesAccess ? 'site_page' : '');
    }

    createAssetRequest.then(function (resp) {
      var editorUrl = _Routes.default.edit(resp.id, _GoodSubTypePythonFieldNames.default[subType]);

      window.location = editorUrl;
    }, function (error) {
      dispatch(_createAsset(purchasedGoodsKey, error));
    }).done();
  };
}

function togglePurchasedPack(goodId) {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.default.TOGGLE_PURCHASED_PACK,
      payload: {
        goodId: goodId
      }
    });
  };
}

function reinstallGood(goodId) {
  var goodName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var updatedVersion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch) {
    _ProductMarketplaceClient.default.reinstallGood(goodId).then(function () {
      dispatch((0, _extends2.default)({
        type: _ActionTypes.default.REDELIVERING_GOOD,
        payload: {
          goodId: goodId
        }
      }, updatedVersion && {
        meta: {
          notification: {
            type: 'success',
            titleText: _I18n.default.text('managePurchases.updatedVersion.titleText'),
            message: _I18n.default.text('managePurchases.updatedVersion.message', {
              goodName: goodName
            })
          }
        }
      }));
    }, function (err) {
      if (err.status === 404 && err.responseJSON.message.includes('Unable to find good')) {
        dispatch({
          type: _ActionTypes.default.REINSTALLATION_UNAVAILABLE,
          meta: {
            notification: {
              titleText: _I18n.default.text('managePurchases.reinstallationUnavailable.titleText'),
              message: _I18n.default.text('managePurchases.reinstallationUnavailable.message'),
              type: 'danger'
            }
          }
        });
      } else {
        dispatch({
          type: _ActionTypes.default.ERROR_REINSTALLING_GOOD,
          payload: err
        });
      }
    }).done();
  };
}

function _uninstallGood(error) {
  if (error) {
    return {
      type: _ActionTypes.default.UNINSTALL_GOOD,
      error: true,
      payload: error
    };
  }

  return {
    type: _ActionTypes.default.UNINSTALL_GOOD
  };
}

function uninstallGood(good, skipValidation) {
  return function (dispatch) {
    dispatch(_uninstallGood());

    _ProductMarketplaceClient.default.uninstallGood(good.get(_DetailsPanelItems.default.TRANSACTION_ID), skipValidation).then(function (purchasedGoods) {
      dispatch(receivePurchasedGoods(purchasedGoods));
    }, function (error) {
      dispatch(_uninstallGood(error));
    }).done();
  };
}

function trackGoodInfo(trackingData) {
  return {
    type: _ActionTypes.default.GOOD_INFO_CLICK,
    trackingData: trackingData
  };
}

function navigateFromGoodDetailsReview(providerUrlToken, goodNameUrlToken) {
  return function (dispatch) {
    var goodDetailsPath = (0, _reactRouter.formatPattern)(UrlPathParams.GOOD_DETAILS_PATH, {
      providerUrlToken: providerUrlToken,
      goodNameUrlToken: goodNameUrlToken
    });
    dispatch((0, _reactRouterRedux.replace)(goodDetailsPath));
  };
}

var resetGoodDetails = function resetGoodDetails() {
  return {
    type: _ActionTypes.default.GOOD_DETAILS_RESET
  };
};

exports.resetGoodDetails = resetGoodDetails;